import React from 'react';
import './tones.css';
import './InlineNotice.css';

/**
 * Faixa persistente dentro da seção afetada. Fica até o problema ser
 * resolvido e sempre oferece uma ação de recuperação.
 *
 * @param {'danger'|'warning'|'info'} tone
 * @param {ReactNode} icon
 * @param {string} title
 * @param {string} text
 * @param {string} actionLabel
 * @param {Function} onAction
 */
const InlineNotice = ({ tone = 'warning', icon, title, text, actionLabel, onAction }) => (
  <div className={`inline-notice feedback-tone--${tone}`} role="status">
    <span className="inline-notice__icon" aria-hidden="true">{icon}</span>
    <div className="inline-notice__body">
      <div className="inline-notice__title">{title}</div>
      <div className="inline-notice__text">{text}</div>
    </div>
    {actionLabel && onAction && (
      <button type="button" className="inline-notice__action" onClick={onAction}>
        {actionLabel}
      </button>
    )}
  </div>
);

export default InlineNotice;
